import React from 'react';
export function BrandsVideoSection() {
  return <section className="w-full" style={{
    marginTop: '65px'
  }} data-id="element-35">
      <div className="flex flex-col md:flex-row w-full lg:h-[472px]" data-id="element-36">
        {/* LEFT: Dark content panel */}
        <div className="w-full md:w-1/2 flex items-center justify-center relative" style={{
        backgroundColor: '#090909',
        padding: '60px 24px'
      }} data-id="element-37">
          <div className="flex flex-col w-full" style={{
          maxWidth: '520px'
        }} data-id="element-38">
            {/* Subtitle — centered */}
            <span className="text-[14px] md:text-[18.75px]" style={{
            color: '#FFF',
            textAlign: 'center',
            fontFamily: 'Poppins, sans-serif',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
            letterSpacing: '1.875px',
            textTransform: 'uppercase' as const,
            marginBottom: '16px'
          }} data-id="element-39">
              Best Brands & Best Marketers
            </span>

            {/* Title — left aligned */}
            <h2 className="text-[40px] leading-[42px] md:text-[65px] md:leading-[65px]" style={{
            color: '#FFF',
            fontFamily: "'League Gothic', Impact, Arial, sans-serif",
            fontStyle: 'normal',
            fontWeight: 400,
            textAlign: 'left'
          }} data-id="element-40">
              The US agencies storming up the World Creative Rankings
            </h2>

            {/* Description — left aligned */}
            <p style={{
            color: '#FFF',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
            textAlign: 'left',
            marginTop: '16px'
          }} data-id="element-41">
              Special Group, a global independent creative network, was the
              year's biggest climber in North America.
            </p>

            {/* Watch Now button */}
            <div className="flex justify-center" style={{
            marginTop: '24px'
          }} data-id="element-42">
              <button className="cursor-pointer transition-all duration-300 ease-in-out bg-transparent text-white border border-white hover:!bg-white hover:!text-black uppercase tracking-wider font-bold" style={{
              width: '170.25px',
              height: '51px',
              borderRadius: '18.75px',
              fontFamily: 'Poppins, sans-serif',
              fontSize: '14px'
            }} data-id="element-43">
                Watch Now
              </button>
            </div>
          </div>
        </div>

        {/* RIGHT: Panda image */}
        <div className="w-full md:w-1/2 relative min-h-[300px] md:min-h-[400px] lg:min-h-0 lg:h-full" data-id="element-44">
          <img src="https://cdn.magicpatterns.com/uploads/szDBDy6gjJq1dh9NM2xP4f/Rectangle_109.jpg" alt="Panda" className="absolute inset-0 w-full h-full object-cover" data-id="element-45" />
          {/* Play button overlay */}
          <div className="absolute inset-0 flex items-center justify-center z-10" data-id="element-46">
            <img src="https://cdn.magicpatterns.com/uploads/oy8QapkJ5YySfwfFaQ2ktA/Polygon_4.svg" alt="Play" className="w-[120px] h-[120px] md:w-[192.75px] md:h-[192.75px]" draggable={false} data-id="element-47" />
          </div>
        </div>
      </div>
    </section>;
}